import React, { useState } from "react";
// componentes
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// redux
import { connect } from "react-redux";
// service
import { updateNotification } from "../../../utils/services/notification";

function EditNotification(props) {
  const { isOpen, toggle } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  //state de erros
  const [titleError, setTitleError] = useState("");
  const [messageError, setMessageError] = useState("");
  //confirmção de edição
  const [successDlg, setSuccessDlg] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  const [title, setTitle] = useState(props.editNotification.title);
  const [editorState, setEditorState] = useState(props.editNotification.text);
  const [textHtml] = useState(props.editNotification.textHtml);
  const [isLoading, setIsLoading] = useState(false);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // valida o form e atualiza a notificação
  async function submitForm() {
    if (title === "") {
      setTitleError("O campo Título é obrigatório.");
      return;
    } else setTitleError("");

    if (editorState === "") {
      setMessageError("O campo Mensagem é obrigatório.");
      return;
    } else setMessageError("");

    const form = {
      title: title,
      text: editorState,
      textHtml: textHtml,
      schedule: props.editNotification.schedule,
      event: props.idEvent,
      sended: props.editNotification.sended,
    };

    setIsLoading(true);
    try {
      const notificationData = await updateNotification(
        form,
        props.state.global_user_data.data.token,
        props.editNotification.id,
      );
      if (notificationData.message === "NOTIFICATION_UPDATED") {
        setSuccessDlg(true);
      } else {
        setSubmitErrorMessage("Erro ao editar notificação.");
      }
    } catch (error) {
      console.error("Erro ao editar notificação:", error);
      setSubmitErrorMessage("Erro ao editar notificação.");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {successDlg ? (
        <SweetAlert
          success
          title={"Editado"}
          onConfirm={() => {
            props.getAllNotification();
            toggle();
            setSuccessDlg(false);
          }}
        >
          {"Notificação editada com sucesso!"}
        </SweetAlert>
      ) : null}
      {submitErrorMessage && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => setSubmitErrorMessage("")}
        >
          {submitErrorMessage}
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Editar Notificação</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitForm();
          }}
        >
          <Row>
            <Col lg={12}>
              <div>
                <label className="form-label">ID da Notificação</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={props.editNotification.id}
                  disabled
                />
              </div>
            </Col>
          </Row>

          <Row style={{ paddingTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Título*</label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={title}
                  onChange={(e) => setTitle(e.target.value)}
                  disabled={props.editNotification.sended}
                />
                {titleError && (
                  <span className="text-danger">{titleError}</span>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ paddingTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Mensagem*</label>
                <textarea
                  className="form-control"
                  type="text"
                  defaultValue={props.editNotification.text}
                  onChange={(e) => setEditorState(e.target.value)}
                  disabled={props.editNotification.sended}
                />
                {messageError && (
                  <span className="text-danger">{messageError}</span>
                )}
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
              paddingTop: 10,
            }}
          >
            <Button
              color="success"
              className="btn btn-danger waves-effect waves-light"
              style={{ width: 80, marginRight: 5 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              action="U"
              isDisabled={
                !props.editNotification.schedule ||
                props.editNotification.sended
              }
            />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(EditNotification);
